define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrClassificationDomain = void 0;
    class SrClassificationDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrClassificationDomain.Primary, value: "Primary" },
                    { key: SrClassificationDomain.Secondary, value: "Secondary" },
                    { key: SrClassificationDomain.Tertiary, value: "Tertiary" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrClassificationDomain.Primary] = 0;
                this.KeyIndex[SrClassificationDomain.Secondary] = 1;
                this.KeyIndex[SrClassificationDomain.Tertiary] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Primary"] = 0;
                this.ValueIndex["Secondary"] = 1;
                this.ValueIndex["Tertiary"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrClassificationDomain = SrClassificationDomain;
    Object.defineProperty(SrClassificationDomain, "Primary", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Primary"
    });
    Object.defineProperty(SrClassificationDomain, "Secondary", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Secondary"
    });
    Object.defineProperty(SrClassificationDomain, "Tertiary", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Tertiary"
    });
    Object.defineProperty(SrClassificationDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
